import React from 'react'
import Icon from 'react-icon-base'

const PersonIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m20 20c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5 7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5z m0 3.8c5 0 15 2.5 15 7.5v3.7h-30v-3.7c0-5 10-7.5 15-7.5z" />
    </g>
  </Icon>
)

export default PersonIcon
